import React, { Component } from 'react';
import { Form, Row, Col, Button } from 'reactstrap';
import AdvancedCompoundInput from './AdvancedCompoundInput';
import AdvancedWordInput from './AdvancedWordInput';
import AddWordInputGroup from './AddWordInputGroup';
import NoDataAlert from '../search-components/NoDataAlert';
import { getAdvanced } from '../actions';
import { groupBy } from '../dataTransform';

const wordInputDefaults = {
  word: '',
  lema: false,
  exact: false,
  pos: 'nesvarbu',
  w1: false,
  w2: false,
  w3: false,
  main: false,
  wordValid: true,
};

const collInputDefaults = {
  sr: 'nesvarbu',
  wc: '0',
  freq: '0',
  arbitral: 'nesvarbu',
};

class AdvancedSearchForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      coll: {
        sr: 'nesvarbu',
        wc: '0',
        freq: '0',
        arbitral: 'nesvarbu',
      },
      srSelect: [
        { value: 'nesvarbu', name: 'Nesvarbu' },
        { value: 'atributinis', name: 'Atributinis' },
        { value: 'subjektinis', name: 'Subjektinis' },
        { value: 'aplinkybinis', name: 'Aplinkybinis' },
        { value: 'objektinis', name: 'Objektinis' },
      ],
      wcSelect: [
        { value: '0', name: 'Nesvarbu' },
        { value: '2', name: 'Dvižodžiai' },
        { value: '3', name: 'Trižodžiai' },
      ],
      freqSelect: [
        { value: '0', name: 'Nesvarbu' },
        { value: '1', name: '> 10 kartų' },
        { value: '2', name: '> 50 kartų' },
        { value: '3', name: '> 100 kartų' },
        { value: '4', name: '> 500 kartų' },
      ],
      arbitralSelect: [
        { value: '0', name: 'Nesvarbu' },
        { value: '1', name: 'Taip' },
        { value: '2', name: 'Ne' },
      ],
      posSelect: [
        { value: 'nesvarbu', name: 'Nesvarbu' },
        { value: 'dkt.', name: 'Daiktavardis' },
        { value: 'vksm.', name: 'Veiksmažodis' },
        { value: 'bdv.', name: 'Būdvardis' },
        { value: 'sktv.', name: 'Skaitvardis' },
        { value: 'prv.', name: 'Prieveiksmis' },

      ],
      w1: {
        word: '',
        lema: false,
        exact: false,
        pos: 'nesvarbu',
        w1: false,
        w2: false,
        w3: false,
        main: false,
        type: 'w1',
        wordValid: true,
      },
      w2: {
        word: '',
        lema: false,
        exact: false,
        pos: 'nesvarbu',
        w1: false,
        w2: false,
        w3: false,
        main: false,
        type: 'w2',
        wordValid: true,
      },
      w3: {
        word: '',
        lema: false,
        exact: false,
        pos: 'nesvarbu',
        w1: false,
        w2: false,
        w3: false,
        main: false,
        type: 'w3',
        wordValid: true,
      },
      showW2: false,
      showAddW2: true,
      showW3: false,
      showAddW3: false,
      noResults: false,
    };

    this.handleCollInputChange = this.handleCollInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSetState = this.handleSetState.bind(this);
    this.handleSimpleSetState = this.handleSimpleSetState.bind(this);
    this.addCard = this.addCard.bind(this);
    this.setNoResults = this.setNoResults.bind(this);
  }

  setNoResults = (value) => {
    this.setState({ noResults: value })
  };

  handleW1Change = (event) => {
    this.handleInputChange(event, 'w1')
  };
  handleW2Change = (event) => {
    this.handleInputChange(event, 'w2')
  };
  handleW3Change = (event) => {
    this.handleInputChange(event, 'w3')
  };
  handleW1MainCheckbox = (event) => {
    this.onMainChange(event, 'w1')
  };
  handleW2MainCheckbox = (event) => {
    this.onMainChange(event, 'w2')
  };
  handleW3MainCheckbox = (event) => {
    this.onMainChange(event, 'w3')
  };
  handleCollInputChange = (event) => {
    this.handleInputChange(event, 'coll')
  };
  handleLemaFormChangeW1 = (event) => {
    this.onLemaFormChange(event, 'w1');
  };
  handleLemaFormChangeW2 = (event) => {
    this.onLemaFormChange(event, 'w2');
  };
  handleLemaFormChangeW3 = (event) => {
    this.onLemaFormChange(event, 'w3');
  };
  handleWordValidationW1 = (value) => {
    this.handleSetState('w1', 'wordValid', value);
  };
  handleWordValidationW2 = (value) => {
    this.handleSetState('w2', 'wordValid', value);
  };
  handleWordValidationW3 = (value) => {
    this.handleSetState('w3', 'wordValid', value);
  };

  handleInputChange = (event, type) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.handleSetState(type, name, value);
  };

  handleSetState = (type, name, value) => {
    this.setState(prevState => {
        return {
          [type]: {
            ...prevState[type], [name]: value
          },
        }
      }
    );
  };

  handleSimpleSetState = (name, value) => {
    this.setState({ [name]: value });
  };

  onLemaFormChange = (event, type) => {
    const target = event.target;
    const value = target.checked;
    const name = target.name;
    let names = ['lema', 'exact'];
    if (value) {
      names.splice(names.indexOf(name), 1);
      this.handleSetState(type, name, value);
      this.handleSetState(type, names[0], !value);
    } else {
      this.handleSetState(type, name, value);
    }
  };

  onMainChange = (event, type) => {
    const target = event.target;
    const value = target.checked;
    const name = target.name;
    let types = ['w1', 'w2', 'w3'];

    if (value) {
      types.splice(types.indexOf(type), 1);
      this.handleSetState(type, name, value);
      this.handleSetState(types[0], name, false);
      this.handleSetState(types[1], name, false);
    } else {
      this.handleSetState(type, name, value);
    }
  };

  prepareData(data, count, form_count) {
    let groupedData = groupBy(data);
    this.props.onLemaAdded(groupedData, count, form_count);
  };

  handleSubmit(event) {
    event.preventDefault();
    this.props.handleSimpleSetState('loading', true);
    this.props.clearLemaData();
    getAdvanced(this.state.coll, this.state.w1, this.state.w2, this.state.w3, 1, this.props.sort)
      .then(response => {
        if (response.data.count === 0) {
          this.setNoResults(true);
        } else {
          this.props.handleSimpleSetState('firstRequestDone', true);
          this.setNoResults(false);
          this.prepareData(response.data.mwe, response.data.count, response.data.form_count);
          this.props.saveRequest(
            {
              coll: this.state.coll,
              w1: this.state.w1,
              w2: this.state.w2,
              w3: this.state.w3,
            });
        }
      })
      .catch(error => {
        console.log(error);
      })
      .then(() => {
        this.props.handleSimpleSetState('page', 1);
        this.props.handleSimpleSetState('loading', false);
      });
  }

  addCard() {
    if (!this.state.showW2) {
      this.handleSimpleSetState('showW2', true);
      this.handleSimpleSetState('showAddW2', false);
      this.handleSimpleSetState('showW3', false);
      this.handleSimpleSetState('showAddW3', true);
    } else if (!this.state.showW3) {
      this.handleSimpleSetState('showW2', true);
      this.handleSimpleSetState('showW3', true);
      this.handleSimpleSetState('showAddW3', false);
      this.handleSimpleSetState('showAddW2', false);
    }
  }

  resetDefaultParams(type) {
    const data = (type === 'coll') ? collInputDefaults : wordInputDefaults;
    Object.keys(data).forEach(key => {
      this.handleSetState(type, key, data[key]);
    });
  }

  resetDefaultsW1 = () => {
    this.resetDefaultParams('w1');
  };
  resetDefaultsW2 = () => {
    this.resetDefaultParams('w2');
  };
  resetDefaultsW3 = () => {
    this.resetDefaultParams('w3');
  };
  resetDefaultsColl = () => {
    this.resetDefaultParams('coll');
  };

  render() {
    const srDisabled = this.state.coll.wc === '3' || this.state.w1.w3 || this.state.w2.w3 || this.state.w3.w3;
    const wc2 = this.state.coll.wc === '2' || this.state.coll.sr !== 'nesvarbu';
    const wc2Disabled = this.state.w1.w3 || this.state.w2.w3 || this.state.w3.w3;
    const wc3Disabled = this.state.coll.sr !== 'nesvarbu';
    const notFilled = this.state.coll.sr === 'nesvarbu' &&
      this.state.coll.wc === '0' && this.state.coll.freq === '0' && this.state.coll.arbitral === 'nesvarbu' &&
      this.state.w1.word.trim() === '' && this.state.w1.pos === 'nesvarbu' &&
      this.state.w2.word.trim() === '' && this.state.w2.pos === 'nesvarbu' &&
      this.state.w3.word.trim() === '' && this.state.w3.pos === 'nesvarbu';
    const mainAndPosition = (this.state.w1.main && (this.state.w1.w1 || this.state.w1.w2 || this.state.w1.w3))
      || (this.state.w2.main && (this.state.w2.w1 || this.state.w2.w2 || this.state.w2.w3))
      || (this.state.w3.main && (this.state.w3.w1 || this.state.w3.w2 || this.state.w3.w3));
    const searchDisabled = (notFilled && !mainAndPosition) || this.state.w1.wordValid === false ||
      this.state.w2.wordValid === false || this.state.w3.wordValid === false;

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <Row>
            <Col sm={12} md={3}>
              <AdvancedCompoundInput
                sr={this.state.coll.sr} wc={this.state.coll.wc} freq={this.state.coll.freq}
                arbitral={this.state.coll.arbitral} arbitralSelect={this.state.arbitralSelect}
                srSelect={this.state.srSelect} wcSelect={this.state.wcSelect} freqSelect={this.state.freqSelect}
                resetDefaults={this.resetDefaultsColl}
                srDisabled={srDisabled} onInputChange={this.handleCollInputChange}
                wc2Disabled={wc2Disabled} wc3Disabled={wc3Disabled}
              />
            </Col>
            <Col sm={12} md={3}>
              <AdvancedWordInput word={this.state.w1} posSelect={this.state.posSelect}
                                 wordValid={this.state.w1.wordValid}
                                 resetDefaults={this.resetDefaultsW1}
                                 onLemaFormChange={this.handleLemaFormChangeW1}
                                 setValidation={this.handleWordValidationW1}
                                 wc2={wc2} onInputChange={this.handleW1Change}
                                 onMainChange={this.handleW1MainCheckbox}/>
            </Col>
            <Col sm={12} md={3}>

              {this.state.showW2 &&
              <AdvancedWordInput word={this.state.w2} posSelect={this.state.posSelect}
                                 wordValid={this.state.w2.wordValid}
                                 resetDefaults={this.resetDefaultsW2}
                                 onLemaFormChange={this.handleLemaFormChangeW2}
                                 setValidation={this.handleWordValidationW2}
                                 wc2={wc2} onInputChange={this.handleW2Change}
                                 onMainChange={this.handleW2MainCheckbox}
              />}
              {this.state.showAddW2 &&
              <div className="p-2 h-100">
                <AddWordInputGroup addCard={this.addCard}/>
              </div>
              }
            </Col>
            <Col sm={12} md={3}>
              {this.state.showW3 &&
              <AdvancedWordInput word={this.state.w3} posSelect={this.state.posSelect}
                                 wordValid={this.state.w3.wordValid}
                                 resetDefaults={this.resetDefaultsW3}
                                 onLemaFormChange={this.handleLemaFormChangeW3}
                                 setValidation={this.handleWordValidationW3}
                                 wc2={wc2} onInputChange={this.handleW3Change}
                                 onMainChange={this.handleW3MainCheckbox}
              />}
              {this.state.showAddW3 &&
              <div className="p-2 h-100">
                <AddWordInputGroup addCard={this.addCard}/>
              </div>
              }
            </Col>
          </Row>
          <Button disabled={searchDisabled} block className="search-button">Ieškoti</Button>
        </Form>

        <NoDataAlert noResults={this.state.noResults}/>
      </div>

    );
  }
}

export default AdvancedSearchForm;
